const baseUrl = 'https://f5s6qaw2yl.execute-api.sa-east-1.amazonaws.com';
export default baseUrl;
